export type ShipmentLineStockEffectV1 = 'dispatch' | 'none';

export interface ShipmentStockPolicyLine {
  food_id?: string | null;
  production_id?: string | null;
  stock_effect_v1?: ShipmentLineStockEffectV1 | string | null;
}

/**
 * Resolves whether a shipment line owns a physical stock movement.
 *
 * New writers persist `stock_effect_v1` on every line. The fallback is only
 * for rows created before that contract: finished-meal lines in a collective
 * tenant were historically linked to a food even though T-425 explicitly
 * made them descriptive and non-stock-backed.
 *
 * Unknown explicit values fail closed to the legacy physical rule here; the
 * shared schema and PostgreSQL wrapper reject them when the row is mutated.
 */
export function shipmentLineStockEffectV1(
  line: ShipmentStockPolicyLine,
  collettivaEnabled: boolean,
): ShipmentLineStockEffectV1 {
  if (line.stock_effect_v1 === 'dispatch') return 'dispatch';
  if (line.stock_effect_v1 === 'none') return 'none';
  if (Object.prototype.hasOwnProperty.call(line, 'stock_effect_v1')) {
    return line.food_id ? 'dispatch' : 'none';
  }
  if (collettivaEnabled && line.production_id) return 'none';
  return line.food_id ? 'dispatch' : 'none';
}

export function shipmentLineReservesStockV1(
  line: ShipmentStockPolicyLine,
  collettivaEnabled: boolean,
): boolean {
  return !!line.food_id
    && shipmentLineStockEffectV1(line, collettivaEnabled) === 'dispatch';
}
